const isObject = (value) => value && typeof value === "object";

export const getAccountUserName = (user) => {
  if (!isObject(user)) {
    return "Player";
  }

  return user.username || user.name || user.displayName || "Player";
};

export const getAccountUserSteamId = (user) => {
  if (!isObject(user)) {
    return "";
  }

  return (
    user.steamid ||
    user.steam_id ||
    user.steamid64 ||
    user.steamId ||
    user.steamID ||
    ""
  );
};

export const getAccountUserAvatar = (user, fallback = null) => {
  if (!isObject(user)) {
    return fallback;
  }

  return (
    user.avatar ||
    user.avatar_url ||
    user.profilePicture ||
    user.profile_picture ||
    fallback
  );
};

export const isAccountUserStaff = (user) => {
  if (!isObject(user)) {
    return false;
  }

  const role = typeof user.role === "string" ? user.role.toLowerCase() : "";

  return Boolean(
    user.isStaff ||
    user.is_staff ||
    user.isAdmin ||
    user.is_admin ||
    user.isSuperuser ||
    user.is_superuser ||
    user.staff ||
    user.admin ||
    role === "staff" ||
    role === "admin" ||
    role === "superuser",
  );
};

export const isAccountUserAuthenticated = (user) =>
  Boolean(
    isObject(user) &&
    (user.id != null ||
      user.user_id != null ||
      Boolean(getAccountUserSteamId(user)) ||
      Boolean(user.email) ||
      user.isAuthenticated),
  );

export const getAccountUserDisplayName = (user) => {
  if (!isObject(user)) {
    return "Guest";
  }

  return (
    user.displayName ||
    user.display_name ||
    user.fullName ||
    user.full_name ||
    getAccountUserName(user)
  );
};

export const normalizeAccountUser = (rawUser) => {
  if (!isObject(rawUser)) {
    return {
      id: null,
      username: "Guest",
      displayName: "Guest",
      steamId: "",
      avatar: null,
      isStaff: false,
      isAuthenticated: false,
      email: null,
      createdAt: null,
      updatedAt: null,
    };
  }

  return {
    ...rawUser,
    id: rawUser.id ?? rawUser.user_id ?? null,
    username: getAccountUserName(rawUser),
    displayName: getAccountUserDisplayName(rawUser),
    steamId: getAccountUserSteamId(rawUser),
    avatar: getAccountUserAvatar(rawUser),
    isStaff: isAccountUserStaff(rawUser),
    isAuthenticated: isAccountUserAuthenticated(rawUser),
    email: rawUser.email || null,
    createdAt: rawUser.created_at || rawUser.createdAt || null,
    updatedAt: rawUser.updated_at || rawUser.updatedAt || null,
  };
};
